<div class="printable-template">
  <lib-cfs-template
    *ngIf="template?.generatedBody"
    class="w-100"
    [animationType]="TemplateAnimationType.Static"
    [template]="template"
    [forPrint]="true"
    (print)="onPrint()">
  </lib-cfs-template>
</div>
